import React from 'react';
import { useConfiguration } from '../../context/configurationContext';
import loadable from '@loadable/component';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getListingsById } from '../../ducks/marketplaceData.duck';

const SectionBuilder = loadable(
  () => import(/* webpackChunkName: "SectionBuilder" */ '../PageBuilder/PageBuilder'),
  {
    resolveComponent: components => components.SectionBuilder,
  }
);

const FooterComponent = (props) => {
  const { footer = {}, topbar } = useConfiguration();

  // If footer asset is not set, let's not render Footer at all.
  if (Object.keys(footer).length === 0) {
    return null;
  }

  // The footer asset does not specify sectionId or sectionType. However, the SectionBuilder
  // expects sectionId and sectionType in order to identify the section. We add those
  // attributes here before passing the asset to SectionBuilder.
  const footerSection = {
    ...footer,
    sectionId: 'footer',
    sectionType: 'footer',
    linkLogoToExternalSite: topbar?.logoLink,
  };

  return <SectionBuilder sections={[footerSection]} options={{isFeaturedListing: props?.isFeaturedListing}} />;
};

// NOTE: if you want to add dynamic data to FooterComponent,
//       you could just connect this FooterContainer to Redux Store
//
const mapStateToProps = state => {
  const {
  isFeatured
  } = state.LandingPage;
  const { currentUser } = state.user;
  const isFeaturedListing = getListingsById(state, isFeatured);
  return { currentUser, isFeaturedListing };
};
const FooterContainer = compose(connect(mapStateToProps))(FooterComponent);
export default FooterContainer;

// export default FooterComponent;
